import { EPipelineSegment, i18n } from '@progress-fe/core';
import { SEGMENT_TYPE_OPTIONS } from './PipelineConfigJsField.constants';
/**
 * Build segment definitions for each segment type
 * @returns Record<EPipelineSegment, TPipelineSegment>
 * @example {pipe: {basic: {...}, heat_loss: {...}}, ...}
 */
export const buildSegmentDefinitions = () => {
    let result = {};
    Object.values(EPipelineSegment).map((enumValue) => {
        result = {
            ...result,
            [enumValue]: {
                basic: {
                    segment_name: { value: '-' },
                    segment_type: { value: enumValue },
                    length: { value: '' },
                    inside_diameter: { value: '' },
                    outside_diameter: { value: '' },
                    material: { value: 'user', disabled: true },
                    increment: { value: '' }
                },
                heat_loss: {
                    vapor_phase: { value: '' },
                    temperature: { value: '' },
                    pressure: { value: '' }
                }
            }
        };
    });
    return result;
};
/**
 * Get menu items grouped by segment type
 * @returns ISvgMenuItem<string>[]
 */
export const getSegmentMenuItems = () => {
    const groups = SEGMENT_TYPE_OPTIONS.map((g) => g.group);
    const uniqueGroups = [...new Set(groups.filter((g) => g !== undefined))];
    return uniqueGroups.map((group) => {
        const itemsByGroup = SEGMENT_TYPE_OPTIONS.filter((item) => item.group === group);
        return {
            id: group,
            icon: itemsByGroup[0].icon,
            name: i18n.t(`enum.pipelineGroupSegment.${group}`),
            items: itemsByGroup.map((item) => ({
                id: item.value,
                name: item.label,
                icon: item.icon
            }))
        };
    });
};
//# sourceMappingURL=PipelineConfigJsField.helpers.js.map